import { getUsers } from '@/api/users'
import {
  getClientStatus,
  addNewClient,
  getClientsList,
  getOneClient,
  updateOneClient,
  addNewEmploee,
  updateOneEmployee,
  getContractList,
  getComments,
  createComments,
  deleteComment,
  updateOneRequisite,
  addNewRequisite,
  getActivitySpheres,
  getTargets,
  getAttachmentFiles,
  addAttachmentFiles,
  deleteAttachmentFiles,
  deleteOneRequisite,
  getClientGroups,
  getClientPaymentTypes,
  getClientInterested,
  getClientRequests,
  getOneEmployee,
  getPaymentInstallmentsOfContract,
  getEmployee,
} from '@/api/clients'

export default {
  GET_STATUS_CLIENT({ commit }) {
    return new Promise((resolve, reject) => {
      getClientStatus().then(response => {
        resolve(response.data)
        commit('SET_STATUS_CLIENT', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  FETCH_ACTIVITY_SPHERES({ commit }) {
    return new Promise((resolve, reject) => {
      getActivitySpheres().then(response => {
        resolve(response.data)
        commit('SET_ACTIVITY_SPHERES', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  FETCH_TARGETS({ commit }) {
    return new Promise((resolve, reject) => {
      getTargets().then(response => {
        resolve(response.data)
        commit('SET_TARGETS', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  ADD_NEW_CLIENT(_, data) {
    return addNewClient(data)
  },
  UDATE_ONE_CLIENT(_, data) {
    return updateOneClient(data)
  },
  FETCH_CLIENTS_LIST({ commit }, data) {
    return new Promise((resolve, reject) => {
      getClientsList(data).then(response => {
        resolve(response.data)
        commit('SET_CLIENTS_LIST', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  FETCH_ONE_CLIENT({ commit }, id) {
    return new Promise((resolve, reject) => {
      getOneClient(id).then(response => {
        resolve(response.data)
        commit('SET_CLIENT', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  ADD_NEW_EMPLOYEE(_, data) {
    return new Promise((resolve, reject) => {
      addNewEmploee(data).then(response => {
        resolve(response.data)
        // commit('SET_CLIENT', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  UPDATE_ONE_EMPLOYEE(_, data) {
    return new Promise((resolve, reject) => {
      updateOneEmployee(data).then(response => {
        resolve(response.data)
        // commit('SET_CLIENT', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  FETCH_CONTRACT_LIST({ commit }, query) {
    return new Promise((resolve, reject) => {
      getContractList(query).then(response => {
        resolve(response.data)
        commit('SET_CONTRACTS', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  FETCH_COMMENTS({ commit }, query) {
    return new Promise((resolve, reject) => {
      getComments(query).then(response => {
        resolve(response.data)
        commit('SET_COMMENTS', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  POST_COMMENT(_, data) {
    return new Promise((resolve, reject) => {
      createComments(data).then(response => {
        resolve(response.data)
        // commit('SET_COMMENTS', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  DELETE_COMMENT(_, id) {
    return new Promise((resolve, reject) => {
      deleteComment(id).then(response => {
        resolve(response.data)
        // commit('SET_COMMENTS', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  UPDATE_ONE_REQUISITE(_, data) {
    return new Promise((resolve, reject) => {
      updateOneRequisite(data).then(response => {
        resolve(response.data)
        // commit('SET_COMMENTS', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  DELETE_ONE_REQUISITE(_, id) {
    return new Promise((resolve, reject) => {
      deleteOneRequisite(id).then(response => {
        resolve(response.data)
        // commit('SET_COMMENTS', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  ADD_NEW_REQUISITE(_, data) {
    return new Promise((resolve, reject) => {
      addNewRequisite(data).then(response => {
        resolve(response.data)
        // commit('SET_COMMENTS', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  FETCH_USERS_LIST({ commit }, data) {
    return new Promise((resolve, reject) => {
      getUsers(data).then(response => {
        resolve(response.data)
        commit('SET_USERS', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  GET_ATTACHMENT_FILES({ commit }, query) {
    return new Promise((resolve, reject) => {
      getAttachmentFiles(query).then(response => {
        resolve(response.data)
        commit('SET_ATTACHMENT_FILES', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  UPLOAD_ATTACHMENT_FILE(_, data) {
    return new Promise((resolve, reject) => {
      addAttachmentFiles(data).then(response => {
        resolve(response.data)
        // commit('SET_ATTACHMENT_FILES', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  DELETE_ATTACHMENT_FILE(_, id) {
    return new Promise((resolve, reject) => {
      deleteAttachmentFiles(id).then(response => {
        resolve(response.data)
        // commit('SET_ATTACHMENT_FILES', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  FETCH_CLIENT_GROUPS({ commit }) {
    return new Promise((resolve, reject) => {
      getClientGroups().then(response => {
        resolve(response.data)
        commit('SET_CLIENT_GROUPS', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  FETCH_CLIENT_PAYMENT_TYPES({ commit }) {
    return new Promise((resolve, reject) => {
      getClientPaymentTypes().then(response => {
        resolve(response.data)
        commit('SET_CLIENT_PAYMENT_TYPES', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  FETCH_CLIENT_INTERESTED({ commit }) {
    return new Promise((resolve, reject) => {
      getClientInterested().then(response => {
        resolve(response.data)
        commit('SET_CLIENT_INTERESTED', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  FETCH_CLIENT_REQUESTS({ commit }) {
    return new Promise((resolve, reject) => {
      getClientRequests().then(response => {
        resolve(response.data)
        commit('SET_CLIENT_REQUESTS', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  FETCH_ONE_EMPLOYEE({ commit }, data) {
    return new Promise((resolve, reject) => {
      getOneEmployee(data).then(response => {
        resolve(response.data)
        commit('SET_ONE_EMPLOYEE', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  FETCH_EMPLOYEE({ commit }, data) {
    return new Promise((resolve, reject) => {
      getEmployee(data).then(response => {
        resolve(response.data)
        commit('SET_EMPLOYEE', response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  // INSTALLMENTS_CONTRACT
  FETCH_INSTALLMENTS_CONTRACT({ commit }, params) {
    return new Promise((resolve, reject) => {
      getPaymentInstallmentsOfContract(params)
        .then(res => {
          commit('SET_INSTALLMENTS_CONTRACT', res.data)
          resolve(res.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
